import { router as mainRouter } from '@/router/main';
import { maintenanceRouter } from '@/router/maintenance';

const router = import.meta.env.VITE_MAINTENANCE_MODE
  ? maintenanceRouter
  : mainRouter;

export default router;
